/**
 * @generated SignedSource<<f10a0a888452e171e6262b4e268ff399>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueSearch_issueNavigatorProject$data = {
  readonly projectId?: string | null | undefined;
  readonly " $fragmentType": "issueSearch_issueNavigatorProject";
};
export type issueSearch_issueNavigatorProject$key = {
  readonly " $data"?: issueSearch_issueNavigatorProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigatorProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueSearch_issueNavigatorProject",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "025b324686c2ae9e075431d405c9a7eb";

export default node;
